import gql from "graphql-tag";

const InsertProjectSpecialConditionTypeMapping = gql`
  mutation insertProjectSpecialConditionTypeMapping(
    $areaOfConstruction: numeric
    $description: String
    $length: numeric
    $model: String!
    $projectId: uuid!
    $specialConditionTypeId: uuid!
    $typeIdentifier: String!
  ) {
    insert_projectSpecialConditionTypeMapping(
      objects: {
        areaOfConstruction: $areaOfConstruction
        description: $description
        length: $length
        model: $model
        projectId: $projectId
        specialConditionTypeId: $specialConditionTypeId
        typeIdentifier: $typeIdentifier
      }
      on_conflict: {
        constraint: project_special_condition_type_mapping_model_project_id_type_id
        update_columns: [areaOfConstruction, description, length, model, specialConditionTypeId]
      }
    ) {
      returning {
        typeIdentifier
        specialConditionTypeId
        projectId
        model
        length
        id
        description
        areaOfConstruction
      }
    }
  }
`;

export default InsertProjectSpecialConditionTypeMapping;
